import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";

interface RelatedArticle {
  id: string;
  question: string;
  category: string;
}

interface RelatedArticlesProps {
  articles: RelatedArticle[];
  onArticleClick: (articleId: string) => void;
}

const RelatedArticles = ({ articles, onArticleClick }: RelatedArticlesProps) => {
  if (articles.length === 0) return null;

  return (
    <Card className="bg-card border-border">
      <CardContent className="pt-6">
        <h3 className="text-sm font-semibold text-foreground mb-3">Related Articles</h3>
        <div className="space-y-2">
          {articles.map((article) => (
            <Button
              key={article.id}
              variant="ghost"
              className="w-full justify-between text-left h-auto py-2"
              onClick={() => onArticleClick(article.id)}
            >
              <span className="text-sm text-muted-foreground truncate">{article.question}</span>
              <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0 ml-2" />
            </Button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default RelatedArticles;
